export class Controller {

    /** @ngInject */
    constructor($state, $translate, Alert, DirectoriesResource) {
        this.$state = $state;
        this.$translate = $translate;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
    }

    resendVerifications() {

        this.isSaving = true;

        this.Alert('info', 'company.user-directories.directory-groups.directory.bulk-verification.re-sending-verifications');

        this.DirectoriesResource
            .resendVerifications(this.companyId, this.directoryId)
            .then(() => {
                this.Alert('success', 'company.user-directories.directory-groups.directory.bulk-verification.re-sending-verifications-success');
            })
            .catch(() => {
                this.Alert('danger', 'company.user-directories.directory-groups.directory.bulk-verification.re-sending-verifications-error');
            })
            .finally(() => this.isSaving = false)
    }

    templateUrl() {
        return require(`./bulk-verification-${this.$translate.use()}.html`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/bulk-verification/bulk-verification.controller.js